export const defaultPrimaryColor = "#226d30";

export const defaultSecondaryColor = "#add13f";

export const defaultTertiaryColor = "#dee2df";
